import { useEffect, useRef, useState, type FormEvent } from "react";
import type { LineStaff } from "./useWeek39LineStaff";

export function Week39LineStaffCell({ date, lineName, rowSpan, record, canEdit, loaded, unavailable, save, idSuffix = "", complete = false }: {
  date: string; lineName: string; rowSpan: number; record: LineStaff | undefined; canEdit: boolean; loaded: boolean; unavailable: boolean;
  idSuffix?: string; complete?: boolean;
  save: (input: { date: string; lineName: string; count: number; expectedVersion: number }) => Promise<LineStaff>;
}) {
  const value = record?.count.toString() ?? "";
  const [draft, setDraft] = useState(value);
  const lastSavedValue = useRef(value);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const dirty = draft !== value;
  useEffect(() => {
    setDraft((current) => current === lastSavedValue.current ? value : current);
    lastSavedValue.current = value;
  }, [value]);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const count = Number(draft);
    if (saving || !dirty || !Number.isInteger(count) || count < 0 || count > 999 || draft.trim() === "") return;
    setSaving(true); setError("");
    try { await save({ date, lineName, count, expectedVersion: record?.version ?? 0 }); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "Kişi sayısı kaydedilemedi."); }
    finally { setSaving(false); }
  };
  return <td className={`pack39-staff-column${complete ? " pack39-merged-complete" : ""}`} rowSpan={rowSpan} data-label="Çalışan kişi">
    {canEdit ? <form onSubmit={(event) => void submit(event)} className="pack39-staff-form">
      <label className="pack39-sr-only" htmlFor={`pack39-staff-${date}-${lineName}-${idSuffix}`}>{date} {lineName} çalışan kişi sayısı</label>
      <input id={`pack39-staff-${date}-${lineName}-${idSuffix}`} type="number" min={0} max={999} step={1} inputMode="numeric"
        value={draft} placeholder="—" disabled={saving} onChange={(event) => { setDraft(event.target.value); setError(""); }}
        aria-invalid={Boolean(error)} aria-describedby={error ? `pack39-staff-error-${date}-${lineName}-${idSuffix}` : undefined} />
      {dirty ? <button type="submit" disabled={saving || draft.trim() === "" || !Number.isInteger(Number(draft)) || Number(draft) < 0 || Number(draft) > 999}>{saving ? "Kaydediliyor" : "Kaydet"}</button> : null}
      {error ? <small id={`pack39-staff-error-${date}-${lineName}-${idSuffix}`} role="alert">{error}</small> : null}
    </form> : <span className="pack39-staff-value">{!loaded ? "Yükleniyor" : unavailable ? "Veri alınamadı" : record ? `${record.count} kişi` : "Girilmedi"}</span>}
  </td>;
}
